import ArticleLayout from '@/components/base/ArticleLayout';
import { articleErrori } from '@/mocks/articles';

export default function ArticleErrori() {
  return <ArticleLayout article={articleErrori} currentSlug="/errori-comuni-itaobuy" />;
}